import { useState } from 'react'
import { randomInt } from '@10000/common'
import { useRequest, useView } from '@10000/react'
import { Avatar, AvatarDialog, Body, Box, Button, Dialog, H4 } from '../../widgets'
import { DropDown, Location, Text } from '../../forms'
import { industries } from '../../../lookups'
import { SettingsForm } from '../'
import { Team, TeamSelect } from './'

export const Organisation = ({ organisationId, onClose }) => {
  const request = useRequest('tenant')
  const { organisations = [], company } = useView('tenant')

  const createdOrganisation = organisations.findIndex(organisation => organisation.id === organisationId) > -1
  const { name, country, city, industry, avatar } = organisations.find(organisation => organisation?.id === organisationId) ||
    { country: company.country, city: company.city, avatar: randomInt(6) }

  const [avatarDialogOpen, setAvatarDialogOpen] = useState(false)
  const [selectedAvatar, setSelectedAvatar] = useState(avatar)

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)

  const [createTeamDialogOpen, setCreateTeamDialogOpen] = useState(false)
  const [selectedTeam, setSelectedTeam] = useState()

  const formattedIndustries = industries.map((industry, index) => ({ label: industry.name, value: index }))

  const avatarSelected = (avatar) => {
    setSelectedAvatar(avatar)
    setAvatarDialogOpen(false)
  }

  const deleteOrganisation = () => request('organisationDeleted', { id: organisationId }).then(() => {
    setDeleteDialogOpen(false)
    onClose()
  })

  const saveTeam = ({ name, country, city, industry }) => request(
    createdOrganisation ? 'organisationUpdated' : 'organisationAdded',
    { id: organisationId, name, country, city, industry, avatar: selectedAvatar }
  ).then(() => {
    if(!createdOrganisation){
      setCreateTeamDialogOpen(true)
    } else {
      onClose()
    }
  })

  return selectedTeam === undefined
    ? <SettingsForm
        onSubmit={saveTeam}
        values={{ name, country, city, industry }}
        title={name || 'New organisation'}
        onBackButtonClick={onClose}
      >
        <Box gap={16} alignItems="center" justifyContent="flex-start" fullWidth >
          <Avatar index={selectedAvatar} mode="company" />
          <Button className="small" onClick={() => setAvatarDialogOpen(true)}>
            Change avatar
          </Button>
        </Box>

        <Text title="Name" name="name" value={name} dark required />
        <DropDown fullWidth dark name="industry" title="Industry" required options={formattedIndustries}/>
        <Location country={country} dark />

        <Box gap={8} column>
          {createdOrganisation && <TeamSelect
            organisationId={organisationId}
            onTeamSelected={setSelectedTeam}
            createdOrganisation={createdOrganisation}
          />}
          {createdOrganisation && <Box fullWidth p="32px 0" justifyContent="flex-start">
            <Box onClick={() => setDeleteDialogOpen(true)} cursor="pointer">
              <Body underline bold alt italic>Delete Organisation</Body>
            </Box>
          </Box>}
        </Box>

        <AvatarDialog value={avatar} mode="company" open={avatarDialogOpen} onClose={avatarSelected}/>

        <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} showControls={false} mobileBackground="white">
          <H4 color="black">Delete organisation</H4>
          <Body color="black" align="center">Deleting this organisation is permanent and all data associated with it will be lost. All teams assigned to this organisation will also be deleted.</Body>
          <Box fullWidth gap={8}>
            <Button fullWidth light onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
            <Button fullWidth onClick={deleteOrganisation}>Delete</Button>
          </Box>
        </Dialog>

        <Dialog open={createTeamDialogOpen} onClose={() => setCreateTeamDialogOpen(false)} showControls={false} mobileBackground="white">
          <H4 color="black">Add a team?</H4>
          <Body color="black" align="center">You can now create teams for you organisation, would you like to do that now?</Body>
          <Box fullWidth gap={8}>
            <Button fullWidth light onClick={onClose}>Save and Exit</Button>
            <Button fullWidth onClick={() => setCreateTeamDialogOpen(false)}>Add a team</Button>
          </Box>
        </Dialog>
      </SettingsForm>
    : <Team teamId={selectedTeam} organisationId={organisationId} onClose={() => setSelectedTeam(undefined)}/>
}